var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg025Messenger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1828_10080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.987305 9.25917C0.987305 12.1725 2.44064 14.7717 4.71314 16.4692V20L8.11814 18.1317C9.02647 18.3825 9.98897 18.5192 10.9865 18.5192C16.509 18.5192 20.9865 14.3742 20.9865 9.26C20.9873 4.14583 16.5098 0 10.9873 0C5.46481 0 0.987305 4.145 0.987305 9.25917H0.987305ZM9.93231 6.66583L12.5406 9.38167L17.4465 6.66583L11.9798 12.4675L9.43397 9.7525L4.46481 12.4683L9.93231 6.66583Z",
    fill: "#3734A9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1828_10080"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.987305)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg025Messenger);
export default __webpack_public_path__ + "static/media/025-messenger.038650bb692fdf3bdd3756a57902d3cc.svg";
export { ForwardRef as ReactComponent };